import React, { useMemo } from "react";
import { Chip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function StatusChip({ row }) {
  const theme = useTheme();

  const status = useMemo(() => {
    const s = String(row?.status || "").trim().toLowerCase();
    if (s) return s;
    // fallback if backend doesn’t provide status
    if (row?.submitted_at) return "submitted";
    return "draft";
  }, [row]);

  const map = {
    draft: { label: "Draft", color: "default" },
    submitted: { label: "Submitted", color: "info" },
    approved: { label: "Approved", color: "success" },
    rejected: { label: "Rejected", color: "error" },
    reopened: { label: "Reopened", color: "secondary" },
  };

  const cfg = map[status] || { label: status || "-", color: "default" };
  const main = theme.palette[cfg.color]?.main || theme.palette.grey[600];

  return (
    <Chip
      size="small"
      label={cfg.label}
      color={cfg.color}
      variant="outlined"
      sx={{
        fontWeight: 900,
        borderRadius: 2,
        bgcolor: alpha(main, 0.12),
      }}
    />
  );
}
